var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"pb-4 dark",class:{'full-width__content': _vm.sidebarToggled},attrs:{"role":"main"}},[_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }